import { useNavigate } from "react-router-dom"
import "../styles/landing.css"

const FEATURES = [
    { icon: "⚡", title: "Real-time scanning",   desc: "Monitors Binance, Bybit, Kraken, OKX and Coinbase simultaneously via WebSocket" },
    { icon: "📊", title: "Spread chart",         desc: "Visualise spread history per trading pair — spot patterns before others do" },
    { icon: "🔔", title: "Instant alerts",       desc: "Get notified on Telegram or email the moment a profitable spread appears" },
    { icon: "🔺", title: "Triangular arbitrage", desc: "Detects A→B→C→A cycles within a single exchange — no transfer fees" },
    { icon: "💸", title: "Fee-adjusted signals", desc: "All spreads shown after trading and withdrawal fees — real profit only" },
    { icon: "🛡", title: "30-day free trial",   desc: "Full access, no credit card required. Cancel any time." },
]

// Removed Team $79 plan — only Free trial + Pro now
const PLANS = [
    { name: "Free trial", price: "$0", period: "30 days", color: "#444", primary: false,
      features: ["All 5 exchanges", "Real-time data", "Telegram + email alerts", "Triangular arbitrage", "30 days full access"], cta: "Start free" },
    { name: "Pro", price: "$29", period: "/ month", color: "#00ffc6", primary: true,
      features: ["All 5 exchanges", "Real-time data", "Telegram + email alerts", "Triangular arbitrage", "Spread history chart", "Custom fee overrides", "Cancel anytime"], cta: "Start 30-day trial" },
]

const STATS = [
    { value: "5",    label: "Exchanges monitored" },
    { value: "<1s",  label: "Alert latency" },
    { value: "500+", label: "Pairs tracked" },
    { value: "24/7", label: "Uptime" },
]

export default function LandingPage() {
    const nav = useNavigate()

    return (
        <div className="landing">

            <nav className="landing-nav">
                <span className="landing-logo">ArbSignal</span>
                <div className="landing-nav-links">
                    <a href="#features">Features</a>
                    <a href="#pricing">Pricing</a>
                    <a onClick={() => nav("/refund")}  style={{cursor:"pointer"}}>Refund</a>
                    <a onClick={() => nav("/terms")}   style={{cursor:"pointer"}}>Terms</a>
                    <a onClick={() => nav("/privacy")} style={{cursor:"pointer"}}>Privacy</a>
                    <button className="nav-login-btn" onClick={() => nav("/login")}>Log in</button>
                </div>
            </nav>

            <section className="hero-section">
                <div className="hero-badge">Live across 5 exchanges</div>
                <h1 className="hero-title">
                    Find crypto arbitrage<br />
                    <span className="hero-accent">before the market closes it</span>
                </h1>
                <p className="hero-sub">
                    Real-time spread scanning with Telegram alerts.
                    Know the exact profit after fees — instantly.
                </p>
                <div className="hero-btns">
                    <button className="primary-btn" onClick={() => nav(localStorage.getItem("token") ? "/dashboard" : "/register")}>
                        Start 30-day free trial
                    </button>
                    <button className="secondary-btn" onClick={() => nav(localStorage.getItem("token") ? "/dashboard" : "/login")}>
                        {localStorage.getItem("token") ? "Go to dashboard" : "Log in"}
                    </button>
                </div>
                <div className="stats-bar">
                    {STATS.map((s, i) => (
                        <div key={i} className="stat-item">
                            <span className="stat-value">{s.value}</span>
                            <span className="stat-label">{s.label}</span>
                        </div>
                    ))}
                </div>

                <div style={{
                    display: "flex",
                    gap: 24,
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    marginTop: 36,
                    opacity: 0.85,
                }}>
                    <span style={{
                        fontSize: 11,
                        color: "#6b7280",
                        textTransform: "uppercase",
                        letterSpacing: 1.5,
                        fontWeight: 600,
                    }}>
                        Featured on
                    </span>
                    <a href="https://fazier.com/launches/arb-signal.com" target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=launched&theme=neutral"
                            width="120"
                            alt="Fazier badge"
                            style={{ display: "block" }}
                        />
                    </a>
                    <a href="https://openhunts.com" target="_blank" rel="noopener noreferrer" title="OpenHunts Club">
                        <img
                            src="https://cdn.openhunts.com/badges/club.webp"
                            alt="OpenHunts Club Member"
                            width="195"
                            height="105"
                            style={{ width: 150, height: "auto", display: "block" }}
                        />
                    </a>
                </div>
            </section>

            <section className="demo-section">
                <div className="demo-card">
                    <div className="demo-header">
                        <span className="demo-dot red" />
                        <span className="demo-dot yellow" />
                        <span className="demo-dot green" />
                        <span className="demo-title-bar">ArbSignal — Dashboard</span>
                    </div>
                    <div className="demo-body">
                        {[
                            { sym: "BTCUSDT", buy: "binance", sell: "kraken",   spread: "0.341" },
                            { sym: "ETHUSDT", buy: "bybit",   sell: "coinbase", spread: "0.289" },
                            { sym: "SOLUSDT", buy: "okx",     sell: "binance",  spread: "0.512" },
                            { sym: "BNBUSDT", buy: "kraken",  sell: "bybit",    spread: "0.198" },
                        ].map((r, i) => (
                            <div key={i} className="demo-row">
                                <span className="demo-sym">{r.sym}</span>
                                <span className="demo-exch">{r.buy}</span>
                                <span className="demo-arrow">→</span>
                                <span className="demo-exch">{r.sell}</span>
                                <span className={`demo-spread ${parseFloat(r.spread) > 0.3 ? "hot" : ""}`}>
                                    {r.spread}%
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="features-section" id="features">
                <h2 className="section-title">Everything you need to trade smarter</h2>
                <div className="features-grid">
                    {FEATURES.map((f, i) => (
                        <div key={i} className="feature-card">
                            <span className="feature-icon">{f.icon}</span>
                            <h3>{f.title}</h3>
                            <p>{f.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="pricing-section" id="pricing">
                <h2 className="section-title">Simple pricing</h2>
                <p className="section-sub">30-day free trial on all plans. No credit card required to start.</p>
                <div className="pricing-grid" style={{ maxWidth: 700, margin: "0 auto" }}>
                    {PLANS.map((plan, i) => (
                        <div key={i} className={`plan-card ${plan.primary ? "plan-primary" : ""}`}>
                            {plan.primary && <div className="plan-badge">Most popular</div>}
                            <h3 className="plan-name">{plan.name}</h3>
                            <div className="plan-price">
                                <span className="plan-amount" style={{ color: plan.color }}>{plan.price}</span>
                                <span className="plan-period">{plan.period}</span>
                            </div>
                            <ul className="plan-features">
                                {plan.features.map((f, j) => <li key={j}>{f}</li>)}
                            </ul>
                            <button
                                className={plan.primary ? "primary-btn plan-btn" : "secondary-btn plan-btn"}
                                onClick={() => nav("/register")}
                            >
                                {plan.cta}
                            </button>
                        </div>
                    ))}
                </div>
            </section>

            <footer className="landing-footer">
                <span>© 2026 ArbSignal. Not financial advice.</span>
                <div className="footer-links">
                    <a onClick={() => nav("/refund")}  style={{cursor:"pointer"}}>Refund</a>
                    <a onClick={() => nav("/terms")}   style={{cursor:"pointer"}}>Terms</a>
                    <a onClick={() => nav("/privacy")} style={{cursor:"pointer"}}>Privacy</a>
                </div>
            </footer>
        </div>
    )
}
